"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var twilsockerror_1 = require("./twilsockerror");

var TwilsockUpstreamError =
/*#__PURE__*/
function (_twilsockerror_1$Twil) {
  _inherits(TwilsockUpstreamError, _twilsockerror_1$Twil);

  function TwilsockUpstreamError(status, description, body) {
    var _this;

    _classCallCheck(this, TwilsockUpstreamError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TwilsockUpstreamError).call(this, description));
    _this.status = status;
    _this.description = description;
    _this.body = body;
    return _this;
  }

  return TwilsockUpstreamError;
}(twilsockerror_1.TwilsockError);

exports.TwilsockUpstreamError = TwilsockUpstreamError;